import { defineColumnInterface } from "../../lib/defines";
import Component from "./component";

export default defineColumnInterface({
  id: "list-m2m",
  component: Component,
});

